import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerFragmentDoc, SettingsPagePlannerSpecialtyFragmentDoc } from '../../SettingsPage/SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type KarteUserFilteringItemListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type KarteUserFilteringItemListQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', channels: Array<{ __typename?: 'ChannelItem', id: Types.Channel, name: string }> }, planner?: { __typename?: 'Planner', id: string, name: string, slug: string, avatar?: any | null, avatarUrl: string, cover?: any | null, coverUrl?: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday?: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> } | null, specialties: Array<{ __typename?: 'PlannerSpecialty', id: string, name: string }> };

export type ChannelItemOnkarteUserFilteringItemListFragment = { __typename?: 'ChannelItem', id: Types.Channel, name: string };

export type FetchCitiesOnKarteUserFilterItemListQueryVariables = Types.Exact<{
  prefecture: Types.Prefecture;
}>;


export type FetchCitiesOnKarteUserFilterItemListQuery = { __typename?: 'Query', getCitiesByPrefecture: Array<{ __typename?: 'City', jisx0402: JISX0402, name: string }> };

export const ChannelItemOnkarteUserFilteringItemListFragmentDoc = gql`
    fragment ChannelItemOnkarteUserFilteringItemList on ChannelItem {
  id
  name
}
    `;
export const KarteUserFilteringItemListDocument = gql`
    query karteUserFilteringItemList {
  viewer {
    channels {
      ...ChannelItemOnkarteUserFilteringItemList
    }
  }
  planner {
    ...SettingsPagePlanner
  }
  specialties {
    ...SettingsPagePlannerSpecialty
  }
}
    ${ChannelItemOnkarteUserFilteringItemListFragmentDoc}
${SettingsPagePlannerFragmentDoc}
${SettingsPagePlannerSpecialtyFragmentDoc}`;

/**
 * __useKarteUserFilteringItemListQuery__
 *
 * To run a query within a Vue component, call `useKarteUserFilteringItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKarteUserFilteringItemListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useKarteUserFilteringItemListQuery();
 */
export function useKarteUserFilteringItemListQuery(options: VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>(KarteUserFilteringItemListDocument, {}, options);
}
export function useKarteUserFilteringItemListLazyQuery(options: VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>(KarteUserFilteringItemListDocument, {}, options);
}
export type KarteUserFilteringItemListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>;
export const FetchCitiesOnKarteUserFilterItemListDocument = gql`
    query fetchCitiesOnKarteUserFilterItemList($prefecture: Prefecture!) {
  getCitiesByPrefecture(prefecture: $prefecture) {
    jisx0402
    name
  }
}
    `;

/**
 * __useFetchCitiesOnKarteUserFilterItemListQuery__
 *
 * To run a query within a Vue component, call `useFetchCitiesOnKarteUserFilterItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCitiesOnKarteUserFilterItemListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCitiesOnKarteUserFilterItemListQuery({
 *   prefecture: // value for 'prefecture'
 * });
 */
export function useFetchCitiesOnKarteUserFilterItemListQuery(variables: FetchCitiesOnKarteUserFilterItemListQueryVariables | VueCompositionApi.Ref<FetchCitiesOnKarteUserFilterItemListQueryVariables> | ReactiveFunction<FetchCitiesOnKarteUserFilterItemListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>(FetchCitiesOnKarteUserFilterItemListDocument, variables, options);
}
export function useFetchCitiesOnKarteUserFilterItemListLazyQuery(variables?: FetchCitiesOnKarteUserFilterItemListQueryVariables | VueCompositionApi.Ref<FetchCitiesOnKarteUserFilterItemListQueryVariables> | ReactiveFunction<FetchCitiesOnKarteUserFilterItemListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>(FetchCitiesOnKarteUserFilterItemListDocument, variables, options);
}
export type FetchCitiesOnKarteUserFilterItemListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>;